import { render, staticRenderFns } from "./OrderExpand.vue?vue&type=template&id=1746e3ad&"
import script from "./OrderExpand.vue?vue&type=script&lang=js&"
export * from "./OrderExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/OrderExpand.vue
// module id = null
// module chunks = 